import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, change, changeType, icon, color = "primary" }) => {
  const getColorClasses = (colorType) => {
    const colors = {
      primary: "bg-primary/10 text-primary",
      success: "bg-success/10 text-success", 
      warning: "bg-warning/10 text-warning",
      error: "bg-error/10 text-error"
    };
    return colors[colorType] || colors.primary;
  };

  const getChangeColor = (type) => {
    return type === 'positive' ? 'text-success' : type === 'negative' ? 'text-error' : 'text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 micro-animation hover:shadow-sm">
      <div className="flex items-center justify-evenly mb-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(color)}`}>
          <Icon name={icon} size={24} />
        </div>
        <div className="">
           <p className="text-sm font-extrabold text-muted-foreground">{title}</p>
        </div>
        {/* {change && (
          <div className={`flex items-center space-x-1 ${getChangeColor(changeType)}`}>
            <Icon 
              name={changeType === 'positive' ? 'TrendingUp' : changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
              size={16} 
            />
            <span className="text-sm font-medium">{change}</span>
          </div>
        )} */}
      </div>
      
      <div>
        <h3 className="text-2xl font-bold text-foreground mb-1">{ value ? value : '0'} </h3>
       
      </div>
    </div>
  );
};

export default MetricsCard;